import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Box,
  IconButton,
  Typography,
  Stack,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Alert,
  Tooltip
} from '@mui/material';
import { map, cloneDeep, isEmpty, isNull, isEqual, assign } from 'lodash';
import methodPromise from '../../../modules/method-promise-wrapper';

import TablePagination from '../TablePagination';

import handleErrorInClient from '../../../modules/handle-error-in-client';

const LoadDataBase = ({ connectorId, source, limitDataConsulting }) => {
  const [dataToShow, setDataToShow] = React.useState([]);
  const [dataDownload, setDataDownload] = React.useState([]);
  const headersTable = {};
  let nameColumnsTable = [];
  if (!isEmpty(dataDownload)) {
    map(Object.keys(dataDownload[0]), keyData => {
      assign(headersTable, {
        [keyData]: keyData
      });
    });
    nameColumnsTable = map(Object.keys(dataDownload[0]), keyData => keyData);
  }

  const [indexDataSelected, setIndexDataSelected] = React.useState(0);
  const [isDataEmpty, setIsDataEmpty] = React.useState(false);

  const [fieldFilter, setFieldFilter] = React.useState('');
  const [valueFilter, setValueFilter] = React.useState('');

  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const totalCount = dataDownload.length;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const changePage = pageNumber => {
    const indexFilter = itemsPerPage * pageNumber;
    const prevIndexFilter = itemsPerPage * (pageNumber - 1);
    const newDatasToShow = [];
    map(dataDownload, (data, indexTable) => {
      if (indexTable >= prevIndexFilter && indexTable < indexFilter) {
        const newDataObjectToReturn = {};
        map(Object.keys(data), keyData => {
          assign(newDataObjectToReturn, { [keyData]: data[keyData] });
        });
        newDatasToShow.push(newDataObjectToReturn);
      }
    });
    if (!isEmpty(newDatasToShow)) {
      newDatasToShow.splice(0, 0, headersTable);
    }

    setDataToShow(newDatasToShow);
    setCurrentPage(pageNumber);
  };

  const managmentData = async datas => {
    const headers = {};
    const dataTable = [];
    const connector = await methodPromise('connectors.findOne', connectorId);
    const { user, ip, port, databaseName, password, schema } = connector;
    const getTypesFieldSchema = {
      user,
      ip,
      port,
      databaseName,
      password,
      schema,
      tableName: source
    };
    const response = await fetch(
      'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
      {
        method: 'POST',
        body: JSON.stringify({
          connection: getTypesFieldSchema
        }),
        headers: { 'Content-Type': 'application/json' }
      }
    );
    const typesFieldTable = await response.json();
    map(datas, data => {
      const dataClone = cloneDeep(data);
      map(Object.keys(dataClone), key => {
        map(Object.keys(typesFieldTable), keyType => {
          if (
            isEqual(keyType, key) &&
            typesFieldTable[keyType] === 'geometry' &&
            !isNull(dataClone[key])
          ) {
            dataClone[key] = 'Point';
          }
        });

        if (isNull(dataClone[key])) {
          dataClone[key] = 'none';
        }
      });
      dataTable.push(dataClone);
    });

    const tableToShow = [];
    map(dataTable, (data, indexTable) => {
      if (indexTable < itemsPerPage) {
        const newDataObjectToReturn = {};
        map(Object.keys(data), keyData => {
          assign(newDataObjectToReturn, { [keyData]: data[keyData] });
        });
        tableToShow.push(newDataObjectToReturn);
      }
    });

    map(Object.keys(dataTable[0]), keyData => {
      assign(headers, {
        [keyData]: keyData
      });
    });
    if (!isEmpty(tableToShow)) {
      tableToShow.splice(0, 0, headers);
    }

    setDataDownload(dataTable);
    setDataToShow(tableToShow);
  };

  const downloadDataConnection = async (keyFilter = '', value = '') => {
    const connector = await methodPromise('connectors.findOne', connectorId);
    const { user, ip, port, databaseName, password, schema } = connector;
    const serverToConnection = {
      user,
      ip,
      port,
      databaseName,
      password,
      schema,
      tableName: source
    };
    try {
      const limitItems =
        limitDataConsulting !== 'All' ? Number(limitDataConsulting) : limitDataConsulting;
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
        {
          method: 'POST',
          body: JSON.stringify({
            connection: serverToConnection,
            search: !isEmpty(keyFilter) && !isEmpty(value) ? [[keyFilter, value]] : null,
            items_limit: !isEmpty(keyFilter) && !isEmpty(value) ? null : limitItems
          }),
          headers: { 'Content-Type': 'application/json' }
        }
      );
      const answer = await response.json();
      if (!isEmpty(answer) && typeof answer !== 'string') {
        managmentData(answer);
        setIsDataEmpty(false);
        Bert.alert('Datos descargados correctamente', 'success');
      } else {
        setDataToShow([]);
        setIsDataEmpty(true);
        Bert.alert('No se han encontrado datos', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
      Bert.alert('Ha ocurrido un error en la descarga de datos', 'danger');
    }
  };

  const handleFilter = () => {
    if (!isEmpty(valueFilter)) {
      downloadDataConnection(fieldFilter, valueFilter);
    } else {
      downloadDataConnection();
    }
  };

  const exportDataCSV = async () => {
    const connector = await methodPromise('connectors.findOne', connectorId);
    const { user, ip, port, databaseName, password, schema } = connector;
    const serverToConnection = {
      user,
      ip,
      port,
      databaseName,
      password,
      schema,
      tableName: source
    };
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
        {
          method: 'POST',
          body: JSON.stringify({
            connection: serverToConnection,
            search:
              !isEmpty(fieldFilter) && !isEmpty(valueFilter) ? [[fieldFilter, valueFilter]] : null,
            download: true
          }),
          headers: { 'Content-Type': 'application/json' }
        }
      );

      const answer = await response.json();
      if (!isEmpty(answer)) {
        const csvFiles = answer.csv_files;
        if (!isEmpty(csvFiles)) {
          const urlData = csvFiles[0];
          fetch(urlData)
            .then(data => data.blob())
            .then(blob => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = urlData;
              link.click();
            })
            .catch(console.error);
        }
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const importDataCSV = async path => {
    const connector = await methodPromise('connectors.findOne', connectorId);
    const { user, ip, port, databaseName, password, schema } = connector;
    try {
      const serverToConnection = {
        user,
        ip,
        port,
        databaseName,
        password,
        schema,
        tableName: source
      };
      await fetch('https://sd1.ipsgeoprocesing.ipsilum.com/MG/isl/exec_isl', {
        method: 'POST',
        body: JSON.stringify({
          disk: 'data3',
          get_map: false,
          udf_selected: '/home/data3/master_folder/isl/repositorios/file_to_database',
          variables: {
            connection_postgres: serverToConnection,
            file: path
          },
          output_format: null,
          guid_function: 'e1e9e293-8f8b-4cc',
          alias_process: 'Subir a base de datos Pergamino',
          explanation_process: 'Subida de archivo a la base de datos de Pergamino',
          force_repeat: true
        }),
        headers: { 'Content-Type': 'application/json' }
      });
      Bert.alert('Archivo importado correctamente', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const handleFileImportCSV = async event => {
    const file = event.target.files[0];
    event.preventDefault();

    if (!file) {
      Bert.alert('Selecciona un archivo primero', 'danger');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const answer = await response.json();
      if (answer.status === 'OK') {
        const { data } = answer;
        if (!isEmpty(data)) {
          importDataCSV(data.path);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleFile = () => {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.onchange = handleFileImportCSV;
    inputElement.click();
  };

  React.useEffect(() => {
    if (!isEmpty(connectorId)) {
      downloadDataConnection();
    }
  }, []);

  return (
    <Box style={{ width: '100%', marginLeft: '1%', marginTop: '2%' }}>
      <Stack direction="row">
        <Box display="flex" justifyContent="space-between" width="100%">
          <Stack direction="row" display="flex" justifyContent="flex-start">
            <Typography variant="h5" fontWeight="bold">{`Records table ${source}`}</Typography>
          </Stack>
          <Stack direction="row" display="flex" justifyContent="flex-start" marginRight="2%">
            <Tooltip title="Export data" placement="top-start">
              <IconButton
                disabled={isDataEmpty}
                aria-label="comments"
                onClick={() => exportDataCSV()}
              >
                <FontAwesomeIcon icon="file-download" color="blue" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Import data" placement="top-start">
              <IconButton aria-label="comments" onClick={() => handleFile()}>
                <FontAwesomeIcon icon="file-upload" color="blue" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Stack>
      <Stack direction="row" display="flex" justifyContent="flex-start" marginTop="2%" width="100%">
        <FormControl style={{ width: '10%' }} variant="filled">
          <InputLabel id="demo-simple-select-filled-label">Field filter</InputLabel>
          <Select
            labelId="demo-simple-select-filled-label"
            id="demo-simple-select-filled"
            value={fieldFilter}
            onChange={event => setFieldFilter(event.target.value)}
            size="small"
          >
            {map(nameColumnsTable, nameColumn => (
              <MenuItem key={nameColumn} value={nameColumn}>
                {nameColumn}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          id="outlined-basic"
          label="Value filter"
          variant="outlined"
          inputProps={{ style: { fontSize: '0.70rem ' } }} // font size of input text
          style={{ width: '20%' }}
          defaultValue={valueFilter}
          onChange={event => setValueFilter(event.target.value)}
        />
        <Tooltip title="Search" placement="top-start">
          <IconButton
            style={{ marginLeft: '1%' }}
            size="small"
            aria-label="comments"
            onClick={() => handleFilter()}
          >
            <FontAwesomeIcon icon="search" color="blue" />
          </IconButton>
        </Tooltip>
      </Stack>
      {!isEmpty(dataToShow) && (
        <>
          <Stack
            maxHeight="45vh"
            overflow="auto"
            width="98%"
            display="flex"
            justifyContent="space-between"
            marginTop="2%"
          >
            {map(dataToShow, (data, index) => (
              <Stack
                direction="row"
                key={uuid()}
                width="100%"
                backgroundColor={index % 2 !== 0 ? '#D3D3D3' : 'white'}
              >
                {map(data, value => (
                  <Stack
                    backgroundColor={index % 2 !== 0 ? '#D3D3D3' : 'white'}
                    width="100vh"
                    key={uuid()}
                    direction="column"
                    marginRight="1%"
                  >
                    <Typography width="30vh">
                      {index === 0 ? value.toUpperCase() : value}
                    </Typography>
                  </Stack>
                ))}
                <Stack
                  key={uuid()}
                  direction="column"
                  width="100%"
                  display="flex"
                  justifyContent="flex-start"
                >
                  {index > 0 && (
                    <Radio
                      size="small"
                      key={uuid()}
                      checked={indexDataSelected === index}
                      onChange={() => {
                        setIndexDataSelected(index);
                      }}
                      value={indexDataSelected}
                      name="radio-buttons"
                    />
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
          <Box marginRight="5%" maxHeight="5vh">
            <Stack direction="row" display="flex" justifyContent="right">
              <Stack direction="column" marginTop="1%" marginBottom="0%" marginRight="2%">
                <Typography>{`${currentPage} - ${totalPages}`}</Typography>
              </Stack>
              <Stack direction="column" display="flex" justifyContent="flex-end">
                <TablePagination
                  currentPage={currentPage}
                  isPaginationOn
                  itemsPerPage={itemsPerPage}
                  stretchView
                  totalCount={totalCount}
                  changePage={changePage}
                />
              </Stack>
            </Stack>
          </Box>
        </>
      )}
      {isEmpty(dataToShow) && (
        <Stack width="80%" marginTop="2%" direction="row">
          <Alert severity="warning">No se han encontrado datos</Alert>
        </Stack>
      )}
    </Box>
  );
};

LoadDataBase.defaultProps = {
  limitDataConsulting: '50'
};

LoadDataBase.propTypes = {
  connectorId: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  limitDataConsulting: PropTypes.string
};

export default LoadDataBase;
